import { render } from "./App.vue?vue&type=template&id=07a04e91"
const script = {}

import "./App.vue?vue&type=style&index=0&id=07a04e91&lang=css"

import exportComponent from "C:\\Users\\naska\\Desktop\\Javascript Portfolio Projects\\movie-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__